import styled from "styled-components";

export const Container = styled.div`
  background: linear-gradient(137.5deg, #39A086 29.77%, #80DDC8 101.61%), #FFFFFF;
  min-height: 100vh;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding-bottom: 32px;
`;

export const Logo = styled.div`
  display: flex;
  height: 56px;
  align-items: center;
  justify-content: center;
  padding-top: 8px;
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  padding: 24px 24px 40px;
  gap: 20px;
`;

export const IllustrationWrap = styled.div`
  width: 240px;
  max-width: 70vw;
  animation: nf-float-y 4s ease-in-out infinite;
  filter: drop-shadow(0 18px 24px rgba(0, 0, 0, 0.12));

  @keyframes nf-float-y {
    0%   { transform: translateY(0); }
    50%  { transform: translateY(-8px); }
    100% { transform: translateY(0); }
  }
`;

export const Title = styled.div`
  font-weight: 700;
  font-size: 32px;
  line-height: 40px;
  text-align: center;
  color: #FFFFFF;
  letter-spacing: 0.2px;
  opacity: 0;
  animation: nf-fade-up 0.5s ease-out 0.1s forwards;

  @keyframes nf-fade-up {
    from { opacity: 0; transform: translateY(8px); }
    to   { opacity: 1; transform: translateY(0); }
  }
`;

export const Desc = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: rgba(255, 255, 255, 0.92);
  max-width: 320px;
  opacity: 0;
  animation: nf-fade-up-2 0.5s ease-out 0.2s forwards;

  @keyframes nf-fade-up-2 {
    from { opacity: 0; transform: translateY(8px); }
    to   { opacity: 1; transform: translateY(0); }
  }
`;

export const Illustration = (_props: any) => (
    <IllustrationWrap>
        <svg width="100%" viewBox="0 0 240 200" fill="none" xmlns="http://www.w3.org/2000/svg"
             aria-hidden="true">
            {/* soft ground shadow */}
            <ellipse cx="120" cy="176" rx="78" ry="8" fill="#000000" opacity="0.12"/>

            {/* back card */}
            <rect x="46" y="34" width="148" height="116" rx="14" fill="#FFFFFF" opacity="0.22"/>

            {/* front card */}
            <g>
                <rect x="40" y="44" width="148" height="116" rx="14" fill="#FFFFFF"/>
                <rect x="40" y="44" width="148" height="20" rx="14" fill="#E9F2EC"/>
                <rect x="40" y="54" width="148" height="10" fill="#E9F2EC"/>
                <circle cx="52" cy="54" r="2.6" fill="#9ECAA8"/>
                <circle cx="60" cy="54" r="2.6" fill="#C1EAD4"/>
                <circle cx="68" cy="54" r="2.6" fill="#D9E9DF"/>
                <rect x="54" y="78" width="120" height="8" rx="4" fill="#E6EDE9"/>
                <rect x="54" y="94" width="92" height="8" rx="4" fill="#EEF3F0"/>
                <rect x="54" y="110" width="104" height="8" rx="4" fill="#EEF3F0"/>
                <rect x="54" y="126" width="64" height="8" rx="4" fill="#EEF3F0"/>
            </g>

            {/* broken link */}
            <g transform="translate(64 108) rotate(-18)">
                <rect x="-22" y="-11" width="44" height="22" rx="11"
                      fill="none" stroke="#1D896D" strokeWidth="6"/>
            </g>
            <g transform="translate(176 108) rotate(18)">
                <rect x="-22" y="-11" width="44" height="22" rx="11"
                      fill="none" stroke="#1D896D" strokeWidth="6"/>
            </g>

            {/* spark marks */}
            <g stroke="#FFD66E" strokeWidth="3" strokeLinecap="round">
                <line x1="114" y1="92" x2="114" y2="80"/>
                <line x1="126" y1="92" x2="126" y2="80"/>
                <line x1="120" y1="88" x2="120" y2="74"/>
                <line x1="106" y1="100" x2="96" y2="94"/>
                <line x1="134" y1="100" x2="144" y2="94"/>
            </g>

            {/* floating dots */}
            <circle cx="36" cy="60" r="3" fill="#FFFFFF" opacity="0.7"/>
            <circle cx="208" cy="44" r="4" fill="#FFFFFF" opacity="0.55"/>
            <circle cx="214" cy="132" r="3" fill="#FFFFFF" opacity="0.7"/>
            <circle cx="26" cy="144" r="3.5" fill="#FFFFFF" opacity="0.55"/>
            <circle cx="200" cy="170" r="2.5" fill="#FFFFFF" opacity="0.7"/>
        </svg>
    </IllustrationWrap>
);

